import { render } from "./AnniversaryDetailView.vue?vue&type=template&id=478acbe5"
import script from "./AnniversaryDetailView.vue?vue&type=script&lang=js"
export * from "./AnniversaryDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__